export default function ShippingInStoreIcon() {
  return (
    <>
      <g id='Frame' clipPath='url(#clip0_3720_226310)'>
        <path
          id='Vector'
          d='M10.2344 12.0112C10.2344 12.8803 10.5939 13.7138 11.2339 14.3284C11.8739 14.9429 12.7419 15.2881 13.647 15.2881C14.552 15.2881 15.4201 14.9429 16.06 14.3284C16.7 13.7138 17.0596 12.8803 17.0596 12.0112C17.0596 11.1422 16.7 10.3087 16.06 9.69415C15.4201 9.07962 14.552 8.73438 13.647 8.73438C12.7419 8.73438 11.8739 9.07962 11.2339 9.69415C10.5939 10.3087 10.2344 11.1422 10.2344 12.0112Z'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_2'
          d='M20.0822 18.1984L15.2556 22.833C14.829 23.2422 14.2507 23.472 13.6477 23.472C13.0447 23.472 12.4664 23.2422 12.0398 22.833L7.21212 18.1984C5.93947 16.9763 5.0728 15.4192 4.7217 13.7242C4.37061 12.0291 4.55085 10.2722 5.23964 8.67546C5.92843 7.07877 7.09483 5.71405 8.59135 4.75389C10.0879 3.79373 11.8473 3.28125 13.6471 3.28125C15.447 3.28125 17.2064 3.79373 18.7029 4.75389C20.1994 5.71405 21.3658 7.07877 22.0546 8.67546C22.7434 10.2722 22.9237 12.0291 22.5726 13.7242C22.2215 15.4192 21.3548 16.9763 20.0822 18.1984Z'
          stroke='#7B7B7B'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3720_226310'>
          <rect width='27.3008' height='26.215' fill='white' />
        </clipPath>
      </defs>
    </>
  );
}
